import type { DirectoryRecordsInterface } from '~/src/repositories/cms/types/cms.directory.types';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';

export const getMappedReferralUrlsData = (
    productGroups: DirectoryRecordsInterface[] | [],
    referralUrlsData: DictionaryInterface[],
) => {
    const mappedUrlsData = referralUrlsData[0]?.articles?.map((value) => {
        const attributes = value.attributeCategories?.opisaniye?.attributes;
        return {
            productName: value.name || '',
            order: value.order || null,
            referralUrl: attributes?.referralurl?.value || '',
            smallGroupImage: attributes?.smallgroupimage?.value || '',
            productCode: attributes?.productgroup?.value?.code || '',
            knowledgeBaseLink: attributes?.aboutproduct?.value || '',
        };
    });
    return productGroups?.map((item) => {
        const products = mappedUrlsData?.filter((product) => product.productCode === item.code) || [];
        return {
            code: item?.code || '',
            productGroupName: item?.value || '',
            products: products,
            id: item?.id || '',
            smallGroupImage: products.filter((product) => product?.smallGroupImage?.length)[0]?.smallGroupImage || '',
        };
    });
};